import { Icon } from "../Icon"

interface TrailIconProps {
  size?: number
  className?: string
}

export const TrailIcon = ({ size = 18, className }: TrailIconProps) => {
  return (
    <Icon size={size} viewBox="0 0 16 16" className={className}>
      <path
        d="M4 14.6667C5.10457 14.6667 6 13.7712 6 12.6667C6 11.5621 5.10457 10.6667 4 10.6667C2.89543 10.6667 2 11.5621 2 12.6667C2 13.7712 2.89543 14.6667 4 14.6667Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 12.6667H11.6667C12.2855 12.6667 12.879 12.4208 13.3166 11.9832C13.7542 11.5457 14 10.9522 14 10.3333C14 9.71449 13.7542 9.121 13.3166 8.68342C12.879 8.24583 12.2855 8 11.6667 8H4.33333C3.71449 8 3.121 7.75417 2.68342 7.31658C2.24583 6.879 2 6.28551 2 5.66667C2 5.04783 2.24583 4.45434 2.68342 4.01675C3.121 3.57917 3.71449 3.33333 4.33333 3.33333H10"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 5.33333C13.1046 5.33333 14 4.4379 14 3.33333C14 2.22876 13.1046 1.33333 12 1.33333C10.8954 1.33333 10 2.22876 10 3.33333C10 4.4379 10.8954 5.33333 12 5.33333Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
